import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.98043 10.5542H7.84391V18.2258C7.84391 18.3773 7.96663 18.5 8.1181 18.5H11.2777C11.4292 18.5 11.5519 18.3773 11.5519 18.2258V10.5903H13.6941C13.8334 10.5903 13.9506 10.4858 13.9665 10.3475L14.2918 7.52315C14.3008 7.44545 14.2762 7.36763 14.2242 7.30934C14.1721 7.25099 14.0977 7.21759 14.0195 7.21759H11.552V5.44718C11.552 4.91349 11.8393 4.64286 12.4062 4.64286C12.4869 4.64286 14.0195 4.64286 14.0195 4.64286C14.171 4.64286 14.2937 4.52008 14.2937 4.36867V1.77622C14.2937 1.62476 14.171 1.50203 14.0195 1.50203H11.7961C11.7804 1.50126 11.7456 1.5 11.6942 1.5C11.3084 1.5 9.96748 1.57573 8.90821 2.55022C7.73456 3.6301 7.8977 4.92309 7.93669 5.14727V7.21754H5.98043C5.82897 7.21754 5.70624 7.34027 5.70624 7.49173V10.28C5.70624 10.4314 5.82897 10.5542 5.98043 10.5542Z",
		fill: "#0D2976"
	})
});
export default SvgFacebook;
